import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleMinus, faCirclePlus, faEllipsisV, faLock } from '@fortawesome/pro-solid-svg-icons';

import { listItemPropTypes, reorderableListItem } from 'helpers/react_dnd/reorderable_list';

export class Option extends React.Component {
  static propTypes = {
    option: PropTypes.object.isRequired,
    optionLabelName: PropTypes.string.isRequired,
    optionValueName: PropTypes.string.isRequired,
    removable: PropTypes.bool,
    selected: PropTypes.bool,
    targeted: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    ...listItemPropTypes,
  }

  render() {
    const {
      connectDragPreview,
      connectDropTarget,
      connectDragSource,
      removable,
      option,
      optionLabelName,
      optionValueName,
      reorderable,
      selected,
      targeted,
      onClick,
    } = this.props;

    let element = (
      <div
        className={classNames('option p-2 d-flex justify-content-between align-items-center gap-2 overflow-hidden', {
          'border-top': this.props.index > 0,
          clickable: removable,
          locked: !removable,
          targeted,
        })}
        key={option[optionValueName]}
        onClick={() => onClick(option)}
      >
        {reorderable && <FontAwesomeIcon className="text-muted" icon={faEllipsisV} />}
        <div className="flex-fill text-truncate">{option[optionLabelName]}</div>
        {removable ?
          <FontAwesomeIcon className="text-primary" icon={selected ? faCircleMinus : faCirclePlus} />
          :
          <FontAwesomeIcon className="text-muted" icon={faLock} />
        }
      </div>
    );

    if (reorderable) {
      element = connectDropTarget(connectDragPreview(connectDragSource(element)));
    }

    return element;
  }
}

export default reorderableListItem(Option, 'multiselectModal', {
  beginDrag(props) {
    props.onBeginDrag(props.index);
    return { value: props.option[props.optionValueName] };
  },
  endDrag(props, monitor) {
    if (monitor.didDrop()) {
      props.onEndDrag();
    }
  }
});
